import React from 'react';
import { useGetCampaignStatisticsQuery } from '~/api/campaignStatistics/CampaignStatistics.api';
import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import StageStatisticsBody from '~/features/campaigns/components/StageStatisticsBody';
import { Campaign } from '~/api/models/campaign';

interface StageDetailsAndStatisticsProps {
    campaign?: Campaign;
}

const StageDetailsAndStatistics: React.FC<StageDetailsAndStatisticsProps> = ({ campaign }) => {
    const { data: campaignStatistics, isLoading: stageLoading } = useGetCampaignStatisticsQuery(
        campaign?.id!,
        { skip: !campaign?.id }
    );


    return (
        <>
            <div className='width-100pct '>
                {campaignStatistics || stageLoading ? (
                    <StatsWidgets>
                        <StatsWidget>
                            <StatsWidget.Body>
                                <StageStatisticsBody statistics={campaignStatistics?.stageStatistics}
                                                     stageLoading={stageLoading}/>
                            </StatsWidget.Body>
                        </StatsWidget>
                    </StatsWidgets>
                ) : (
                    <div className='display-flex justify-content-center align-items-center height-200'>
                        <span className='text-muted'>No statistics available</span>
                    </div>
                )}
            </div>
        </>
    );
};

export default StageDetailsAndStatistics;
